<template>
    <div class="artists-results">
        <!-- <div class="filters">
            <span class="material-icons">sort</span>
            <h3>Sort Artists By</h3>
            <div class="select-wrap">
                <select v-model="searches.sortBy">
                    <option value="">Default</option>
                    <option value="alpha">Alphabetical</option>
                </select>
            </div>
        </div> -->
        <div class="artists">
            <transition-group name="favorite">
                <Artist
                    v-for="artist in artists"
                    :key="artist.nid"
                    :artist="artist"
                    @click.capture.prevent=""
                    @click="navigate(artist.url)"
                />
            </transition-group>
        </div>
    </div>
</template>

<script>
import ArtworkHelper from "@/mixins/PageHelper.js";

export default {
    name: "Collection",
    mixins: [ArtworkHelper],
    computed: {
        documentTitle() {
            return "Artist Collection | " + this.documentTitleBase;
        },
        artists() {
            const vm = this;
            //if (!vm.searches.sortBy) return vm.allArtists;
            return vm.alphabeticalArtists;
        },
    },
};
</script>

<style lang="scss">
</style>
